import { Box, Text } from '@hopskipdrive/react-components';
import { DescriptionOutlined as DescriptionOutlinedIcon } from '@mui/icons-material';
import { capitalize } from 'lodash';

import { CopyToClipboard } from '../../../../../shared/components/CopyToClipboard';
import { LocationPinIcon } from '../../../../../shared/components/Icons';
import { colorTokens } from '../../../../../shared/components/variables';
import { formatAddressWithAddress2 } from '../../../../utils/helpers/location';
import { InnerCard } from '../TimelineOverview/TimelineOverview.styles';

export const LocationInnerCard = ({ locationDetails, excludeInstructions = false }) => {
  const locationAddressWithStreetAddressTwo = formatAddressWithAddress2(
    locationDetails.address,
    locationDetails.streetAddressTwo
  );

  return (
    <InnerCard>
      <Box display="flex" flexDirection="row" alignItems="center">
        <LocationPinIcon style={{ overflow: 'unset' }} />
        <Text variant="h6">{`Location: ${locationDetails?.name || locationDetails.address}`}</Text>
      </Box>
      <Box gap="4px" ml="20px">
        <CopyToClipboard
          toastMessage="Address Copied"
          text={locationAddressWithStreetAddressTwo}
          variant="body1"
          textStyle={{ fontWeight: 300 }}
        />
        <Text variant="body1" fontWeight={300}>{`Location Type: ${capitalize(locationDetails?.locationType)}`}</Text>
      </Box>
      {locationDetails?.instructions && !excludeInstructions && (
        <Box display="flex" flexDirection="row" alignItems="start">
          <DescriptionOutlinedIcon />
          <Text variant="body1" fontWeight={300} style={{ color: colorTokens.text.secondary, whiteSpace: 'pre-wrap' }}>
            {locationDetails?.instructions}
          </Text>
        </Box>
      )}
    </InnerCard>
  );
};
